(() => {
  function getGrid() {
    return document.querySelector('.size-qty-grid');
  }

  function getProductFormExtras() {
    const properties = {};
    let addonTotal = 0;

    document.querySelectorAll('.po-stack').forEach(stack => {
      const isHidden =
        stack.offsetParent === null ||
        stack.style.display === 'none';

      if (isHidden) return;

      const label = stack.querySelector('.po-label span')?.textContent
        ?.replace('*', '')
        ?.trim();

      const value = stack.querySelector('.po-selected-swatch .po-value')?.textContent
        ?.trim();

      const price = stack.querySelector('.po-extra-price')?.textContent
        ?.trim();

      if (!label || !value) return;

      const displayValue = value;

      properties[` ${label}`] = displayValue;
      properties[`_${displayValue}_price`] = extractMoney(price);
      addonTotal += extractMoney(price);
    });

    const imageUrl = document.querySelector('.po-file-uploaded-name')?.href;
    if (imageUrl) {
      properties[' Print 1 - Image 1'] = imageUrl;
    }

    if (addonTotal > 0) {
      properties.__bss_po_addons = String(addonTotal);
      properties._bssPrice = JSON.stringify({ extra: addonTotal });
    }

    properties._bssVariants = '{}';
    properties._bssCustomAttributes = JSON.stringify(properties);

    return Object.keys(properties).length ? { properties } : {};
  }

  function extractMoney(text) {
    if (!text) return 0;

    const match = text.match(/[\d.]+/);
    return match ? Number(match[0]) : 0;
  }
  function getVariantId() {
    const pickerVariantId = getSelectedVariantIdFromPicker();
    if (pickerVariantId) return pickerVariantId;
    const url = new URL(window.location.href);
    return url.searchParams.get('variant');
  }
  function getSelectedVariantIdFromPicker() {
    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return null;

    const selectedVariantScript = variantSelects.querySelector('[data-selected-variant]');
    if (!selectedVariantScript) return null;

    try {
        const variant = JSON.parse(selectedVariantScript.textContent);
        return variant && variant.id ? variant.id : null;
    } catch (e) {
        return null;
    }
  }
  async function refreshGrid(grid) {
    if (!grid) return;

    const sectionId = grid.dataset.sectionId;
    const variantId = getVariantId();

    const url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);
    if (variantId) url.searchParams.set('variant', variantId);

    try {
        const res = await fetch(url.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);

        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const newGrid = doc.querySelector(`#${CSS.escape(grid.id)}`);
        if (!newGrid) return;

        grid.replaceWith(newGrid);
        initGrid(newGrid);
    } catch (e) {
        console.error('Grid refresh failed', e);
    }
  }

  function getItems(grid) {
    const extras = getProductFormExtras();

    return Array.from(grid.querySelectorAll('.size-qty-grid__input'))
      .filter(i => !i.disabled)
      .map(i => ({
        id: parseInt(i.dataset.variantId, 10),
        quantity: parseInt(i.value || 0, 10),
        ...extras
      }))
      .filter(i => i.id && i.quantity > 0);
  }
  function isOptisValid() {
    if (!document.querySelector('.po-stack')) return true;

    if (!window.BSS_PO?.getSelectedOptions) return false;

    try {
    	return BSS_PO.getSelectedOptions.isValid();
    } catch (e) {
	  return false;
    }
  }
  /*
  // without a check for OPTIS required values.
  function updateButton(grid) {
    const btn = grid.querySelector('[data-bulk-add]');
    if (!btn) return;
    btn.disabled = getItems(grid).length === 0;
  }
*/
  function updateButton(grid) {
    const btn = grid.querySelector('[data-bulk-add]');
    if (!btn) return;

    const hasItems = getItems(grid).length > 0;
    const optisValid = isOptisValid();

    btn.disabled = !hasItems || !optisValid;
  }
  async function bulkAdd(grid) {
    const items = getItems(grid);
    const btn = grid.querySelector('[data-bulk-add]');
    const status = grid.querySelector('[data-bulk-add-status]');
    if (!items.length || !isOptisValid()) {
      updateButton(grid);
      return;
    }

    btn.disabled = true;
    btn.classList.add('is-loading');
    if (status) status.textContent = 'Adding…';

    try {
      const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items,
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname
        })
      });

      const data = await res.json();
      if (data.sections) {
        const cartDrawerHTML = data.sections['cart-drawer'];
        const cartBubbleHTML = data.sections['cart-icon-bubble'];

        if (cartDrawerHTML) {
          const parsed = new DOMParser().parseFromString(cartDrawerHTML, 'text/html');

          const newDrawer =
            parsed.querySelector('cart-drawer') ||
            parsed.querySelector('[data-cart-drawer]') ||
            parsed.body.firstElementChild;

          const currentDrawer =
            document.querySelector('cart-drawer') ||
            document.querySelector('[data-cart-drawer]');

          if (newDrawer && currentDrawer) {
            currentDrawer.replaceWith(newDrawer);
          }
        }

        if (cartBubbleHTML) {
          const parsed = new DOMParser().parseFromString(cartBubbleHTML, 'text/html');

          const newBubble =
            parsed.querySelector('cart-count') ||
            parsed.querySelector('[data-cart-count]') ||
            parsed.body.firstElementChild;

          const currentBubble =
            document.querySelector('cart-count') ||
            document.querySelector('[data-cart-count]');

          if (newBubble && currentBubble) {
            currentBubble.replaceWith(newBubble);
          }
        }
      }
      if (!res.ok) {
        throw new Error(data.description || 'Could not add selected sizes.');
      }

      grid.querySelectorAll('.size-qty-grid__input').forEach(i => {
        if (!i.disabled) i.value = 0;
      });

      updateButton(grid);

      if (status) {
        status.innerHTML = `Added to <a href="${window.Shopify.routes.root}cart">cart</a>`;
      }

      document.dispatchEvent(new CustomEvent('theme:cart:reload'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      setTimeout(() => {
        document.querySelector('[data-cart-toggle]')?.click();
      }, 150);
      btn.disabled = false;
      btn.classList.remove('is-loading');
    } catch (e) {
      if (status) status.textContent = e.message || 'Could not add items.';
	  updateButton(grid);
      //btn.disabled = false;
      btn.classList.remove('is-loading');
    } finally {
      updateButton(grid);
      //btn.disabled = false;
      //btn.classList.remove('is-loading');
    }
    //btn.disabled = false;
    //btn.classList.remove('is-loading');
  }
 

  function initGrid(grid) {
    grid.addEventListener('input', (e) => {
      if (!e.target.matches('.size-qty-grid__input')) return;

      let val = parseInt(e.target.value || 0, 10);
      if (isNaN(val) || val < 0) val = 0;
      e.target.value = val;

      updateButton(grid);
    });

    const btn = grid.querySelector('[data-bulk-add]');
    if (btn) {
      btn.addEventListener('click', () => bulkAdd(grid));
    }

    updateButton(grid);
  }
  // part of the change to ensure required OPTIS values are selected.
  document.addEventListener('BSSOptionSelectionChanged', () => {
    const grid = getGrid();
    if (grid) updateButton(grid);
  });
  
  document.addEventListener('DOMContentLoaded', () => {
    const grid = getGrid();
    if (grid) initGrid(grid);
  });

  // Listen to Broadcast variant changes
  function waitForVariantUrlChange(previousUrl, callback, attempts = 60) {
  let count = 0;

  const check = () => {
    const currentUrl = window.location.href;

    if (currentUrl !== previousUrl) {
      callback();
      return;
    }

    count += 1;
    if (count >= attempts) return;

    setTimeout(check, 100);
  };

  check();
}
  document.addEventListener('change', (e) => {
    const target = e.target;
  if (!target) return;

  const variantSelects = target.closest('variant-selects');
  if (!variantSelects) return;

  // Broadcast swatch / option controls only
  const isVariantControl =
    target.matches('.swatch-input__input[data-option-value-id]') ||
    target.matches('input[type="radio"][data-option-value-id]') ||
    target.matches('select[data-popout-select]') ||
    target.matches('select[name*="option"]');

  if (!isVariantControl) return;

  // Only refresh when the changed control belongs to the Colour option
  const optionName = (target.name || '').toLowerCase();
  const isColourOption =
    optionName.includes('colour') || optionName.includes('color');

  if (!isColourOption) return;

  const previousUrl = window.location.href;
  const grid = getGrid();
  if (!grid) return;

  waitForVariantUrlChange(previousUrl, () => {
    refreshGrid(getGrid());
  });
  });

})();